"use client";

import { useGoogleRating } from "@/hooks/useGoogleRating";
import { useTranslations } from "next-intl";
import { useEffect, useRef, useState } from "react";
import { gsap } from "gsap/dist/gsap";
import { ScrollTrigger } from "gsap/dist/ScrollTrigger";


function Counter() {
  const t = useTranslations("Index");
  const ggRating = useGoogleRating();
  const [stats, setStats] = useState({ value: 0 });
  const [stats2, setStats2] = useState({ value: 0 });
  const triggerRef = useRef(null);

  gsap.registerPlugin(ScrollTrigger);

  useEffect(() => {
    let ctx = gsap.context(() => {
      const target = {
        value: stats.value,
      };

      const target2 = {
        value: stats2.value,
      };

      gsap.to(target, {
        scrollTrigger: {
          trigger: triggerRef.current,
          start: "top bottom",
          end: "+=200%",
          pin: false,
        },
        duration: 3.2,
        value: "+=600",
        roundProps: "value",
        ease: "power1.out",
        onUpdate() {
          setStats({ value: target.value });
        },
      });

      gsap.to(target2, {
        scrollTrigger: {
          trigger: triggerRef.current,
          start: "top bottom",
          end: "+=200%",
          pin: false,
        },
        duration: 4,
        value: "+=70",
        roundProps: "value",
        ease: "power1.out",
        onUpdate() {
          setStats2({ value: target2.value });
        },
      });
    });

    return () => ctx.revert();
  }, []);

  return (
    <div>
      <div
        ref={triggerRef}
        className=" flex flex-1 flex-row items-start justify-between 
                    xl:space-x-[48px] 
                    w-full space-x-[16px] font-degular-display-medium"
      >
        <div className=" flex-1 flex flex-col items-center space-y-[12px] md:space-y-[16px] text-center ">
          <p className=" text-[40px] md:text-[64px] leading-[54px] md:leading-[64px]">
            <span id="counter" className=" font-semibold text-[#F24F1D]">{stats.value}+</span>
          </p>
          <p className=" text-[20px] md:text-[32px] leading-none md:leading-9">
            {t("bookings_per_day")}
          </p>
        </div>
        <div className="flex-1 flex flex-col items-center space-y-[12px] md:space-y-[16px] text-center">
          <p className=" text-[40px] md:text-[64px] leading-[54px] md:leading-[64px]">
            <span id="counter" className=" font-semibold text-[#F24F1D]">{stats2.value}%</span>
          </p>
          <p className=" text-[20px] md:text-[32px] leading-none md:leading-9">
            {t("customer_retention")}
          </p>
        </div>
        <div className="flex-1 flex flex-col items-center space-y-[12px] md:space-y-[16px] text-center">
          <p className=" text-[40px] md:text-[64px] leading-[54px] md:leading-[64px]">
            <span id="counter" className=" font-semibold text-[#F24F1D]">
              {ggRating}
            </span>
          </p>
          <p className=" text-[20px] md:text-[32px] leading-none md:leading-9">
            {t("customer_satisfaction")}
          </p>
        </div>
      </div>
    </div>
  )
}

export default Counter
